import * as type from '../../types/API/bomRawMaterials'

export function getBOMRawMaterials(payload: any) {
    return {
        type: type.GET_BOM_RAW_MATERIALS,
        payload: payload
    }
}

export function addBOMRawMaterials(payload: any) {
    return {
        type: type.ADD_BOM_RAW_MATERIALS,
        payload: payload
    }
}

export function updateBOMRawMaterials(payload: any) {
    return {
        type: type.UPDATE_BOM_RAW_MATERIALS,
        payload: payload
    }
}

export function deleteBOMRawMaterials(payload: any) {
    return {
        type: type.DELETE_BOM_RAW_MATERIALS,
        payload: payload
    }
}

export function issueRawMaterial(payload: any) {
    return {
        type: type.ISSUE_RAW_MATERIAL,
        payload: payload
    }
}

export function linkBom(payload: any) {
    return {
        type: type.LINK_BOM,
        payload: payload
    }
}

export function unlinkBom(payload: any) {
    return {
        type: type.UNLINK_BOM,
        payload: payload
    }
}
